import { jsxs as a, jsx as o } from "react/jsx-runtime";
import { useTranslation as _ } from "react-i18next";
import { filesIcons as t } from "../../../data/mock.js";
import "../../../components/Breadcrumbs/index.js";
import p from "../../../components/Button/index.js";
import "classnames";
import "react";
import "reactjs-popup";
import d from "../../../icons/Close.js";
import "../../../components/ThemeContext/index.js";
import "../../../modal-l0sNRNKZ.js";
import "../../Input/index.js";
import "../../../components/Tooltip/index.js";
const u = "forma-ui__file-dropzone-file-single__file", v = "forma-ui__file-dropzone-file-single__editable", I = "forma-ui__file-dropzone-file-single__fileIcon", g = "forma-ui__file-dropzone-file-single__fileName", N = "forma-ui__file-dropzone-file-single__input", x = "forma-ui__file-dropzone-file-single__remove", z = "forma-ui__file-dropzone-file-single__removeIcon", e = {
  file: u,
  editable: v,
  fileIcon: I,
  fileName: g,
  input: N,
  remove: x,
  removeIcon: z
}, O = ({ name: i, path: r, showName: s, onRemove: m }) => {
  const { t: f } = _(), n = i.lastIndexOf("."), c = i.slice(0, n), l = i.slice(n).toLowerCase();
  return /* @__PURE__ */ a("div", { className: e.file, children: [
    /* @__PURE__ */ o("img", { src: t[l] ? t[l] : t.other, className: e.fileIcon, alt: l }),
    s && /* @__PURE__ */ o("div", { className: e.fileName, children: c }),
    /* @__PURE__ */ o(
      p,
      {
        className: e.remove,
        viewStyle: "text",
        iconClassName: e.removeIcon,
        icon: /* @__PURE__ */ o(d, {}),
        onClick: m,
        title: f("uikit:delete")
      }
    )
  ] }, r);
};
export {
  O as default
};
